import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="signing-window"
export default class extends Controller {
  static values = {
    url: String,
  };

  open() {
    const screenHeight = window.screen.height;
    const screenWidth = window.screen.width;

    const height = screenHeight > 740 ? 700 : Math.floor(screenHeight * 0.8);
    const width = Math.min(Math.floor(screenWidth * 0.8), 800);

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    this.popup = window.open(
      this.urlValue,
      "signingWindow",
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,menubar=no,scrollbars=yes,resizable=yes`,
    );

    if (!this.popup) {
      alert("Please enable popups to continue.");
      return;
    }

    this.popup.focus();

    // Listen for popup signals
    this.handleMessage = this.handleMessage.bind(this);
    window.addEventListener("message", this.handleMessage);

    // Start close polling
    this.closePoll = setInterval(() => {
      if (this.popup.closed) {
        this.cleanup();
        this.refreshFormsFrame();
      }
    }, 300);
  }

  handleMessage(event) {
    // Only process messages from the popup window we opened
    if (event.source !== this.popup) {
      return;
    }

    if (event.data === "signed") {
      // Stop polling — popup will close itself
      this.cleanup();
      this.refreshFormsFrame();
    } else if (event.data?.type === "closeSigningWindow") {
      // Close the popup when requested
      if (this.popup && !this.popup.closed) {
        this.popup.close();
      }
      this.cleanup();
      this.refreshFormsFrame();
    }
  }

  cleanup() {
    clearInterval(this.closePoll);
    window.removeEventListener("message", this.handleMessage);
  }

  refreshFormsFrame() {
    const frame = document.getElementById("forms");
    if (frame) {
      if (typeof frame.reload === "function") {
        frame.reload();
      } else {
        frame.src = frame.src;
      }
    }
  }
}
